const errorConstant = {
  addUserModal: {
    emailAlreadyExists: {
      apiResponse:
        'Request failed with status code 409: The user already exists.',
      errorMessage: 'Email already exists.',
    },
    phoneNumberAlreadyExists: {
      apiResponse: 'User with phone already exists.',
      errorMessage: 'Phone number already exists.',
    },
  },
  ErrorBookAppointment:
    'Unfortunately, we were unable to book the appointment. Please try again.',

  DeclineEventError:
    'Sorry, we were unable to complete your request because this is an active event.',
};

export const API_ERROR = 'Error occurred';

export default errorConstant;
